import { useEffect, useState } from 'react';
import { MapContainer, Marker, TileLayer } from 'react-leaflet';

import L from 'leaflet';
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';
import useMobile from 'hooks/use_mobile';

import 'leaflet/dist/leaflet.css';

// Leaflet's default icon URLs break in bundled environments — override manually
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconUrl: markerIcon,
  iconRetinaUrl: markerIcon2x,
  shadowUrl: markerShadow,
});

const geocode = async (street, zipCode, city, signal) => {
  const q = encodeURIComponent(`${street} ${zipCode} ${city}`);
  const res = await fetch(
    `https://nominatim.openstreetmap.org/search?q=${q}&format=json&limit=1`,
    {
      signal,
      headers: {
        'Accept-Language': 'en',
        'User-Agent': 'probelist-frontend/1.0 (artur.kremens@gmail.com)',
      },
    }
  );
  if (!res.ok) throw new Error(`Nominatim ${res.status}`);
  const data = await res.json();
  if (!data[0]) return null;
  return [parseFloat(data[0].lat), parseFloat(data[0].lon)];
};

const openMapsUrl = (lat, lng, isMobile) => {
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
  if (isMobile && isIOS) return `https://maps.apple.com/?ll=${lat},${lng}`;
  if (isMobile) return `geo:${lat},${lng}?q=${lat},${lng}(Location)`;
  return `https://www.openstreetmap.org/?mlat=${lat}&mlon=${lng}&zoom=16`;
};

const PlaceMap = ({ place }) => {
  const isMobile = useMobile();
  const [coords, setCoords] = useState(null);

  useEffect(() => {
    const controller = new AbortController();

    geocode(place.street, place.zipCode, place.city, controller.signal)
      .then((result) => {
        if (!controller.signal.aborted) setCoords(result);
      })
      .catch((err) => {
        if (err.name !== 'AbortError') console.error('[PlaceMap] geocode failed', err);
      });

    return () => controller.abort();
  }, [place.street, place.zipCode, place.city]);

  if (!coords) return null;

  const [lat, lng] = coords;
  const handleClick = () => {
    window.open(openMapsUrl(lat, lng, isMobile), '_blank', 'noopener,noreferrer');
  };

  return (
    <MapContainer
      center={coords}
      zoom={16}
      style={{ height: 240, width: '100%', borderRadius: 8, marginTop: 16, position: 'relative', zIndex: 0 }}
      scrollWheelZoom={false}
      dragging={false}
      zoomControl={true}
      attributionControl={true}>
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>'
        url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png" />
      <Marker
        position={coords}
        eventHandlers={{ click: handleClick }} />
    </MapContainer>
  );
};

export default PlaceMap;
